import { Checkbox } from "@material-ui/core";
import { useMemo } from "react";

/**
 * Endoso 25 (HU6, iteración 2): columnas de la tabla de recibos. La columna
 * "seleccion" trae su propio checkbox de cabecera ("seleccionar página")
 * porque @mui/x-data-grid v4 en modo server no ofrece selección multipágina.
 *
 * `align` va junto a `headerAlign` en todas las columnas: son props distintas
 * (celda vs. cabecera) y con solo `headerAlign` el checkbox de la cabecera
 * quedaba centrado mientras los de las filas se alineaban a la izquierda.
 */
export const useColumnasRecibos = ({
  estaSeleccionado,
  alternarRecibo,
  seleccionarPagina,
  todosPaginaSeleccionados,
  algunoPaginaSeleccionado,
}) => {
  const columns = useMemo(
    () => [
      {
        field: "seleccion",
        headerName: "",
        flex: 0.5,
        headerClassName: "header",
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderHeader: () => (
          <Checkbox
            color="primary"
            checked={todosPaginaSeleccionados}
            indeterminate={algunoPaginaSeleccionado}
            onChange={seleccionarPagina}
          />
        ),
        renderCell: ({ row }) => (
          <Checkbox
            color="primary"
            checked={estaSeleccionado(row.uuid)}
            onChange={() => alternarRecibo(row)}
          />
        ),
      },
      {
        field: "oficina",
        headerName: "Oficina",
        flex: 0.6,
        headerClassName: "header",
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "ramo",
        headerName: "Ramo",
        flex: 0.6,
        headerClassName: "header",
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "poliza",
        headerName: "Póliza",
        flex: 0.7,
        headerClassName: "header",
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "numeroRecibo",
        headerName: "Recibo",
        flex: 0.8,
        headerClassName: "header",
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "fecha",
        headerName: "Fecha",
        flex: 0.7,
        headerClassName: "header",
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "importe",
        headerName: "Importe",
        flex: 0.7,
        headerClassName: "header",
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      todosPaginaSeleccionados,
      algunoPaginaSeleccionado,
      estaSeleccionado,
      alternarRecibo,
      seleccionarPagina,
    ]
  );
  return columns;
};
